import { Box, makeStyles } from '@material-ui/core';
import { KeyboardBackspace } from '@material-ui/icons';
import { Link, useLocation, useParams } from '@reach/router';
import React from 'react';
import { useTranslation } from 'react-i18next';

import CompanyChartImageSrc from '../../../../../assets/images/company-chart.png';
import OwnershipChartImageSrc from '../../../../../assets/images/ownership-chart.png';
import { getPath } from '../../../../../core/utils/routes.utils';
import { toCssValue } from '../../../../../core/utils/theme.utils';
import { ROUTES } from '../../../../../routes';
import { useCompaniesState } from '../../../shared/CompanyContext/CompanyContext';

const ConnectionsBlock: React.FC = () => {
  const classes = useStyles();
  const { company, dataset, dbVersion } = useCompaniesState();
  const { t } = useTranslation();
  const { benchmarkId } = useParams();
  const { pathname } = useLocation();

  const ownershipPath = getPath(
    ROUTES.benchmarking.ownership,
    ROUTES.financialData.ownershipChart,
    {
      benchmarkId,
      companyUid: company?.companyInfo?.id,
      dataset,
      dbVersion,
    },
  );
  const connectionsPath = getPath(
    ROUTES.benchmarking.connections,
    ROUTES.financialData.companyChart,
    {
      benchmarkId,
      companyUid: company?.companyInfo?.id,
      dataset,
      dbVersion,
    },
  );

  return (
    <Box className={classes.connectionsBlock}>
      <Box className={classes.ownershipBlock}>
        <img src={OwnershipChartImageSrc} alt="connections.jpg" />
        <Link to={ownershipPath} className={classes.link} state={{ companyDetailsPath: pathname }}>
          {t('connections:discoverOwnership')} <KeyboardBackspace className={classes.arrow} />
        </Link>
      </Box>
      <Box className={classes.companyBlock}>
        <img src={CompanyChartImageSrc} alt="connections.jpg" />
        <Link
          to={connectionsPath}
          className={classes.link}
          state={{ companyDetailsPath: pathname }}
        >
          {t('connections:exploreConnections')} <KeyboardBackspace className={classes.arrow} />
        </Link>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  connectionsBlock: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '330px',
    marginLeft: theme.spacing(8),
    minHeight: '210px',
    justifyContent: 'space-between',
  },
  companyBlock: {
    height: '98px',
    position: 'relative',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.primary.contrastText,
    padding: toCssValue([theme.spacing(5), theme.spacing(7)]),
    textAlign: 'right',
    '& a': {
      left: theme.spacing(6),
      backgroundColor: theme.palette.primary.dark,
    },
  },
  ownershipBlock: {
    height: '98px',
    position: 'relative',
    flexDirection: 'column',
    backgroundColor: '#506278',
    color: theme.palette.primary.contrastText,
    padding: toCssValue([theme.spacing(5), theme.spacing(7)]),
    '& a': {
      right: theme.spacing(6),
      backgroundColor: '#506278',
    },
  },
  link: {
    position: 'absolute',
    bottom: theme.spacing(6),
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    justifyContent: 'center',
    textTransform: 'uppercase',
    padding: toCssValue(theme.spacing(5)),
    color: theme.palette.background.paper,
    height: '32px',
    border: `1px solid ${theme.palette.primary.contrastText}`,
  },
  arrow: {
    marginLeft: '10px',
    transform: 'rotate(-180deg)',
  },
}));

export default ConnectionsBlock;
